var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 25C106.8 25 25 106.8 25 208s81.8 183 183 183 183-81.8 183-183S309.2 25 208 25zm121.3 22.81c21 15.91 38.7 35.83 52.1 58.59 49.1 41.7 93.4 100.9 92 179.2-.6 34.4-7.3 75.5-19.4 110.3-12.1 34.7-30.1 62.3-49.7 71.7-3.9 1.8-9.5 2.2-17.5.6-8-1.7-17.9-5.3-29.3-10-22.7-9.5-51.2-23.4-84.2-33.5-66.2-20.1-152-24.2-247.5 50.6l11.1 14.2c91.2-71.5 168.3-66.7 231.1-47.6 31.4 9.6 59 23 82.6 32.9 11.7 4.9 22.5 8.9 32.6 11 10.1 2.1 20 2.3 28.9-2 27.5-13.1 46-45.1 58.9-82 12.9-36.9 19.8-79.5 20.4-115.8 1.6-92.8-55.5-160.5-111.9-204.3-17.2-13.42-34.5-24.69-50.2-33.89zM208 52c16 0 32 4 48 12 0 32-32 80-48 80s-48-48-48-80c16-8 32-12 48-12zM107.4 94.4c27.7 16 53.3 67.7 45.4 81.6-8.1 13.8-65.6 17.5-93.33 1.5 2.14-35.7 18.13-63.4 47.93-83.1zm201.2 0c29.9 19.7 45.9 47.4 48 83.1-27.7 16-85.3 12.3-93.3-1.5-8-13.9 17.6-65.6 45.3-81.6zM208 167c22.5 0 41 18.5 41 41s-18.5 41-41 41-41-18.5-41-41 18.5-41 41-41zm0 18c-12.8 0-23 10.2-23 23s10.2 23 23 23 23-10.2 23-23-10.2-23-23-23zm-98.1 42.8c20.3.2 38.6 4.7 42.9 12 7.9 13.9-17.7 65.6-45.4 81.6-29.83-19.7-45.83-47.4-47.97-83.1 12.97-7.5 32.52-10.7 50.47-10.5zm196.2 0c18-.2 37.5 3 50.5 10.5-2.1 35.7-18.1 63.4-48 83.1-27.7-16-53.3-67.7-45.3-81.6 4.3-7.3 22.5-11.8 42.8-12zM208 271.7c16 .1 48 48.1 48 80.1-32 16-64 16-96 0 0-32 32-80 48-80.1z",
    fill: "currentcolor",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.8538208578190f9bf14ab10776285d1f.svg";
export { ForwardRef as ReactComponent };